import MapLayer from '../map-layer.enum';
import setPortsLayer from '../port-utils/ports-layer';

function addRoutesPortsLayer(layer: MapLayer | string, metadata?: {}) {
  return setPortsLayer(layer, metadata);
}

export default addRoutesPortsLayer;
